<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{name:'ExamIndex'}">在线测评</router-link>
      <span class="slash">/</span>
      <span class="current">套卷练习</span>
    </div>
    <list
      class="list"
      :autoGetData="false"
      ref="list"
      url="/api/app/practice/package"
      :limit="16"
      :search="search"
    >
      <template v-slot="{list}">
        <div class="package-list clearfix">
          <template v-for="item in list">
            <div
              class="package"
              :key="item.id"
              @click="$router.push({name:'ExamPackagePaper',query:{id:item.id}})"
            >
              <div class="name">{{item.name}}</div>
              <div class="bottom">
                <span class="num">{{item.practiceNum}}人已练习</span>
                <span class="count">共{{item.exams_count}}套</span>
              </div>
            </div>
          </template>
        </div>
        <Empty v-if="list.length==0" class="empty" title="暂无套卷练习，敬请期待！" />
      </template>
    </list>
  </div>
</template>
<script>
export default {
  name: "ExamPackage",
  data() {
    return {
      search: {
        attr_val_id: ""
      }
    };
  },
  async created() {
    this.search.attr_val_id = await this.$services.ExamService.getAttrValId();
    this.$refs.list.searchRefresh();
  }
};
</script>
<style lang="scss" scoped>
.package {
  width: 280px;
  height: 158px;
  padding: 20px 23px 17px 20px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  margin: 0 26px 26px 0;
  float: left;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;

  &:nth-child(4n) {
    margin-right: 0;
  }

  .name {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .num {
    font-size: 14px;
    color: rgba(153, 153, 153, 1);
    line-height: 1;
  }

  .count {
    font-size: 14px;
    color: $primary-color;
    line-height: 1;
  }
}
</style>